import { useState } from "react";
import { Table, Space, Button, message, Modal } from "antd";
import InstitutionService from "../../../services/InstitutionService";
import InstitutionModalForm from "./InstitutionModalForm";

const getColumns = (showModalForm, setInstitutionTarget, showModalDelete) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Siglas",
      dataIndex: "shortName",
      width: "150px",
      key: "shortName",
      render: (text, record) => <span>{record.shortName}</span>,
    },
    {
      title: "Pais",
      dataIndex: "country",
      width: "150px",
      key: "country",
      render: (text, record) => <span>{record.country}</span>,
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setInstitutionTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setInstitutionTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};

export default function Institution({ list = [], getData, setInstitutions }) {
  const [institutionTarget, setInstitutionTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    InstitutionService.deleteInstitution(institutionTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Institución eliminada.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setInstitutions(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de Institución.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar la moneda. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setInstitutionTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setInstitutionTarget(null);
        setIsModalFormVisible(false);
        setInstitutions(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de monedas.", 5);
      });
  };

  const handleCancelForm = () => {
    setInstitutionTarget(null);
    setIsModalFormVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{ marginBottom: "1em" }}
      >
        +Registrar nueva Institución
      </Button>
      <Table
        columns={getColumns(showModalForm,setInstitutionTarget,showModalDelete)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <InstitutionModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          institutionTarget={institutionTarget}
        />
      ) : null}
      {isModalDeleteVisible?(
        <Modal
        visible={isModalDeleteVisible}
        title="Eliminar Institución"
        onOk={handleOkDelete}
        onCancel={handleCancelDelete}
        okText="Aceptar"
        cancelText="Cancelar"
      >
        <p>
          ¿Desea eliminar la Institución{" "}
          <strong>
            {institutionTarget?.name + " - " + institutionTarget?.shortName}
          </strong>
          ?
        </p>
      </Modal>
      ):null}
    </>
  );
}
